"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("../../../core");
const getTestDriveVehicles = async () => {
    const response = await (0, core_1.apiRequest)(core_1.API_ENDPOINTS.TestDrive.getAll.toString());
    return response.data.result;
};
exports.default = getTestDriveVehicles;
